import client from './client';

export interface ShowcaseItem {
    id: number;
    title: string;
    imageUrl: string;
    content: string;
    sortOrder: number;
    active: boolean;
    userId?: string | number;
    commentCount: number;
    comments?: any[];
}

export const getShowcaseItems = async (): Promise<ShowcaseItem[]> => {
    // client base URL is /api
    const response = await client.get('/admin/showcase');
    return response.data;
};

// Also for comments
export const getShowcaseComments = async (showcaseId: number) => {
    const response = await client.get(`/admin/showcase/${showcaseId}/comments`);
    return response.data;
};

export const createShowcaseComment = async (showcaseId: number, content: string) => {
    const rawUserId = localStorage.getItem('userId');
    const userId = (rawUserId && rawUserId !== 'null' && rawUserId !== '') ? rawUserId : null;

    const payload = {
        content: content.trim(),
        nickname: localStorage.getItem('nickname') || '익명',
        userId: userId
    };

    console.log('[sohn] Creating comment payload:', payload);

    try {
        const response = await client.post(`/admin/showcase/${showcaseId}/comments`, payload);
        console.log('[sohn] Comment creation response:', response.data);
        return response.data;
    } catch (error) {
        console.error('[sohn] Comment creation failed:', error);
        throw error;
    }
};

export const deleteShowcaseItem = async (id: number) => {
    const response = await client.delete(`/admin/showcase/${id}`);
    return response.data;
};
